import {Directive, TemplateRef} from "@angular/core";
import {DxPageHeaderBaseDirective} from "./dx-page-header-base.directive";

/**
 * Структурная директива для переопределения шаблона области под раздел уведомлений в шапке.
 * @publicApi
 */
@Directive({selector: '[dxPageHeaderNotificationBar]'})
export class DxPageHeaderNotificationBarDirective extends DxPageHeaderBaseDirective {
  constructor(public template: TemplateRef<any>) {
    super();
  }
}
